import { Popover } from 'antd';
import { AppBox } from './boxes/AppBox';

export function AppPopup({ as, ...rest }) {
  return <AppBox {...rest} as={Popover} />;
}
